import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Group } from '@era/security-sdk';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'era-group-list-item-ui',
  templateUrl: './group-list-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, FaIconComponent],
})
export class GroupListItemComponent {
  public readonly group = input.required<Group>();
  public readonly isEditing = input(false);
  public readonly isSelected = input(false);

  readonly deleteEvent = output<Group>();

  delete(group: Group) {
    this.deleteEvent.emit(group);
  }
}
